import Clients from "./Clients";
import ProductCarousel from "../Carousel/ProductCarousel";
import CategorywiseProducts from "../Category/CategorywiseProducts";

const Home = () => {
  return (
    <div className="text-white flex flex-col gap-10">
      <ProductCarousel />
      <CategorywiseProducts category={"camera"} title={"CCTV Section"} />
      <Clients />
    </div>
  );
};

export default Home;
